module.exports = __webpack_public_path__ + "f9f6c935147e3b58b39c6603f0991551.fbx";